export default {"src":"/_next/static/media/spin.b6d18744.svg","height":1024,"width":896};